import { version } from "../../version.json";

export const environment = {
    version,
    production: true,
    siteUrl: "",
    serverUrl: "https://services-prod.fyes.gr/api/fyes",
    sentryDsn: "",
    iosAppUrl: "",
    androidAppUrl: "",
};
